import { render, staticRenderFns } from "./Data_widget.vue?vue&type=template&id=52731aec&scoped=true&lang=pug&"
import script from "./Data_widget.vue?vue&type=script&lang=js&"
export * from "./Data_widget.vue?vue&type=script&lang=js&"
import style0 from "./Data_widget.vue?vue&type=style&index=0&id=52731aec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52731aec",
  null
  
)

export default component.exports